import { Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import { Select                   } from 'src/app/interface/select/select';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'custom-select',
  templateUrl: './custom.select.html',
  styleUrls: ['./custom.select.scss']
})
export class CustomSelect implements OnInit, Select 
{
  @Input() adaptive: boolean = false

  @Input() autoSelectFirst: boolean = false
  @Input() selectAll      : boolean = true

  @Input  () title_none     : string  
  @Input  () title_single   : string  
  @Input  () title_multiple : string  

  @Input  () values         : any[]
  @Input  () selectFirstById: number
  @Input  () multiple       : boolean = false
  @Input  () disabled       : boolean = false

  @Input() enabled        : number  = 1

  @Output () change: EventEmitter<any> = new EventEmitter<any>()
  currentValue: any

  constructor() {}

  async ngOnInit() 
  {    
    if(this.values) this.retriveValues(this.values)

    if   (this.selectFirstById && this.selectFirstById != -1) this.setSelectedValueById(this.selectFirstById)
    else this.selectFirst()

    if(this.autoSelectFirst           ) this.selectFirst()   
    if(this.multiple && this.selectAll) this.allSetter  ("all")
  }

  getSelectedValue() {
    return this.currentValue
  }

  setSelectedValue(value: any): void 
  {
    this.currentValue = (value)
    this.change.emit(value)
  }

  setSelectedValueById(id: number): void 
  {
    console.log(this.values, id);

    if(id)
    {      
      this.values.forEach(value => {        
        if(value.id == id) this.setSelectedValue(value)
      });
    }
    else this.selectFirst()
  }

  clearSelectedValue(): void 
  {
    this.setSelectedValue(undefined)

  }

  selectFirst (): void 
  {    
    if ( this.values && this.values.length > 0) {
      if ( this.multiple ) 
        this.setSelectedValue([this.values[0]] )
      else{
        this.setSelectedValue(this.values[0]   )
      }
    }
  }

  selectElement(el: any): void 
  {
    const find = this.searchElement(el)
    if (find) this.setSelectedValue(find)
  }

  searchElement(el: any): any
  {
    if (!this.values) return undefined

    return this.values.find ( (org) => org.id == el.id ) 
  }

  retriveValues( values: any [])
  {
    this.values = values
  }

  onChange(slChange: MatSelectChange) 
  {
    this.setSelectedValue(slChange.value)
  }

  isDisabled(){
    return this.disabled 
  }

  disableOption(value: any){
    return this.multiple && this.currentValue.length == 1 && value == this.currentValue[0]
  }

  allSetter(setter: string){
    if (setter == "all") 
    {
      this.setSelectedValue(this.values.filter( () => true))
    }else{
      this.setSelectedValue([this.values[0]])
    }
  }
}
